import React, { useEffect, useState } from 'react';
import { CnBox, CnButton, CnIcon, CnLoading } from '@cainiaofe/cn-ui';
import { queryQuestions } from '../../services/apiList';

import './index.scss';

const AiQuestionList = (props) => {
  const { title, hasRefresh, handleClickQuestionItem, mode, chatId, deviceId } =
    props;
  const [list, setList] = useState([]);
  const [url, setUrl] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (mode === 'Q') {
      // 咨询问题
      handleQueryQuestions();
    } else {
      // 推荐职位
      initPositionQuestions();
    }
  }, [mode]);

  const handleQueryQuestions = () => {
    setLoading(true);
    queryQuestions({
      deviceId,
      chatId,
      mode
    })
      .then((resData) => {
        setList(resData?.recommendQuestions);
        setUrl(resData?.questionUrl);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const initPositionQuestions = () => {
    setLoading(true);
    setTimeout(() => {
      setList(['直接输入想要的职位要求', '按照简历信息进行推荐']);
      setLoading(false);
    }, 500);
  };

  return (
    <div className="ai-question-list-wrap">
      <CnBox
        className="ai-question-list-title"
        direction="row"
        align="center"
        justify="space-between"
      >
        <span>{title}</span>
        {hasRefresh && (
          <CnButton text>
            <CnIcon type="refresh" onClick={handleQueryQuestions} />
          </CnButton>
        )}
      </CnBox>
      <CnLoading className="ai-question-list-loading" visible={loading}>
        <CnBox spacing={8}>
        {list?.map((item) => (
          <div
            className="ai-question-list-item"
            onClick={() => {
              handleClickQuestionItem(item);
            }}
          >
            {item}
          </div>
        ))}
        {url && (
          <div
            className="ai-question-list-item ai-question-list-item-all"
            onClick={() => window.open(url)}
          >
            查看全部FAQ
          </div>
        )}
        </CnBox>
      </CnLoading>
    </div>
  );
};

export default AiQuestionList;
